import i18next from '../../config/i18next';
import i18nUser from './i18n/fr.json';
import DisableLineSheetsPage from './pages/disable-line-sheets-page';

i18next.addResourceBundle('fr', 'disable-line-sheets', i18nUser);

export { DisableLineSheetsPage };
